export type GiveawayCampaign = {
  id?: string;
  slug: string;
  enabled: boolean;
  starts_at: string | null;
  ends_at: string | null;
  display_order: number;
  winner_count: number;
  prize_name: string;
  prize_short: string;
  prize_value: string;
  prize_specs: string;
  prize_hook: string;
  prize_image_url: string;
  entry_rule: string;
  judging_rule: string;
  entries_close: string;
  winners_named: string;
  rules_url: string;
};

export const defaultCampaign: GiveawayCampaign = {
  slug: "beta-2026",
  enabled: true,
  starts_at: null,
  ends_at: null,
  display_order: 10,
  winner_count: 3,
  prize_name: "Klein Tools Tradesman Pro XL Backpack",
  prize_short: "Klein Tradesman Pro XL",
  prize_value: "$172.78 retail",
  prize_specs: "40 pockets, molded bottom, ballistic weave, USB-C port",
  prize_hook: "Your phone runs FieldProve all day. This bag charges it.",
  prize_image_url: "/default-backpack.webp",
  entry_rule: "Use FieldProve on at least three real service calls and submit the feedback survey.",
  judging_rule: "Judged on how useful your feedback was. Not a random draw.",
  entries_close: "",
  winners_named: "",
  rules_url: "https://beta.fieldprove.com/legal/giveaway-rules",
};
